import {Typography} from '@mui/material';

interface OnboardingSectionTitleProps {
  title: string;
}

export default function OnboardingSectionTitle({title}: OnboardingSectionTitleProps) {
  return (
    <Typography mb={4} variant='h3'>
      {title}
    </Typography>
  );
}
